import { FC } from 'react';
import { AlertIcon } from 'assets';
import * as S from './styled';
import { ErrorWrapperDescription } from './styled';

const ErrorUnderForm: FC<{ disabled?: boolean }> = ({ disabled }) => {
  return (
    <S.ErrorWrapper>
      <S.ErrorWrapperHeader>
        <AlertIcon wh="24" />
        <S.ErrorWrapperTitle>The email or password is incorrect</S.ErrorWrapperTitle>
      </S.ErrorWrapperHeader>
      <ErrorWrapperDescription>
        Oops! Something’s not right. Check your email and password and try again.
      </ErrorWrapperDescription>
    </S.ErrorWrapper>
  );
};

export default ErrorUnderForm;
